import React, { useEffect, useState } from 'react';

interface TypingTextProps {
    text: string;
    speed?: number;
    className?: string;
    style?: React.CSSProperties;
}

export const TypingText: React.FC<TypingTextProps> = ({ text, speed = 50, className = '', style }) => {
    const [displayedText, setDisplayedText] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (currentIndex < text.length) {
            const timeout = setTimeout(() => {
                setDisplayedText(prev => prev + text[currentIndex]);
                setCurrentIndex(prev => prev + 1);
            }, speed);

            return () => clearTimeout(timeout);
        }
        return undefined;
    }, [currentIndex, text, speed]);

    useEffect(() => {
        // Reset when text changes
        setDisplayedText('');
        setCurrentIndex(0);
    }, [text]);

    return (
        <span className={className} style={style}>
            {displayedText}
        </span>
    );
};
